import React from "react";
import { XIcon } from "lucide-react";
import { pains } from "../data/content";
export function PainSection() {
  return <section className="border-t border-line bg-panel px-5 py-20" data-id="element-67" data-mp="38wlusvaiuwis">
      <div className="mx-auto grid max-w-5xl items-center gap-12 lg:grid-cols-2" data-id="element-68" data-mp="2uyotxmp1c3yb">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/7923d0c0-22d8-43a3-a16b-eaabf34d5feb.jpg" alt="Un professeur de guitare montre une fiche de cours à son élève" className="w-full rounded-2xl" data-id="element-69" data-mp="2yzquq7yloo2e" />
        <div data-id="element-70" data-mp="2q0nah0np62mb">
          <h2 className="font-display text-4xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-71" data-mp="2q15h8r7zjz8h">
            Enseigner, vous adorez. <span className="text-gold" data-id="element-72" data-mp="2g996ogopqgnd">Planifier, beaucoup moins.</span>
          </h2>
          <ul className="mt-8 space-y-4" data-id="element-73" data-mp="2g6wqo92imgcy">
            {pains.map(p => <li key={p} className="flex gap-3 text-lg text-mute" data-id="element-74" data-mp="229zz25ekouv0">
                <XIcon className="mt-1 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-75" data-mp="278ulrifnv3ke" />
                {p}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic text-cream" data-id="element-76" data-mp="3rp3qonrpnlkv">
            Et si chaque cours était déjà prêt, imprimé, et pensé pour faire progresser vos élèves ?
          </p>
        </div>
      </div>
    </section>;
}